import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=c9a5160a&"
import script from "./TransactionsView.vue?vue&type=script&lang=ts&"
export * from "./TransactionsView.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports